import * as React from "react"
import {useHighLevelCalloutQuery} from "../../../hooks/useHighLevelCalloutQuery";
import {Bundle} from "./bundle";
import {WorksWellWithCarousel} from "../crossSells/carousels/worksWellWith";

export const HighLevelCallout = () => {
    const {
        bundleModel,
        worksWellWithCrossSells,
        error
    } = useHighLevelCalloutQuery();

    // If there is an error, don't render anything
    if (error) return <></>;

    // If there is a bundle, render it instead of the works well with carousel
    if (bundleModel) return <Bundle model={bundleModel}/>;

    // If there are no works well with cross-sells, don't render anything
    if (worksWellWithCrossSells.length < 1) return <></>;

    // Otherwise, render the works well with carousel
    return <div id="topLevelWorksWith"><WorksWellWithCarousel crossSells={worksWellWithCrossSells}/></div>;
}